module.exports = __webpack_public_path__ + "img/alex-sleeping-face.18ceb746.png";